import Image from '../../Image';
import AvailabilityMessage from '../../AvailabilityMessage/AvailabilityMessage';
import { translate } from '@micro-apps/env';
import './SquareImageCard.scss';

interface SquareImageCardProps {
	title: string;
	link: string;
	image?: string;
	description?: string;
	statusMessage?: {
		iconColor: string;
		message: string;
	};
	subtitles: { icon: string; text: string }[];
	urgencyTag?: string;
	duration?: string;
	callout: string;
	qualifier?: string;
	note?: string;
}

export default function SquareImageCard({
	title,
	link,
	image,
	statusMessage,
	duration,
	callout,
	qualifier,
	note,
	urgencyTag,
}: SquareImageCardProps) {
	return (
		<div className="SquareImageCard DynamicProduct">
			<a href={link} className="SquareImageCard-link">
				<div className="Image Image-ratioContainer SquareImageCard-image">
					<picture className="Image-picture">
						{urgencyTag && (
							<span className="SquareImageCard-featured-tag labels-label">{urgencyTag}</span>
						)}
						<Image className="Image-img" alt={title} src={image} />
					</picture>

					{statusMessage && (
						<AvailabilityMessage
							iconColor={statusMessage.iconColor}
							message={statusMessage.message}
						/>
					)}
				</div>

				<div className="SquareImageCard-Details">
					<span className="SquareImageCard-title subtitle-2">{title}</span>
					{duration && (
						<span className="SquareImageCard-duration flex items-center gap-060 text-body3 text-text-secondary">
							<span className="icon icon-time" aria-hidden="true" />
							{duration}
						</span>
					)}
					{callout && (
						<div className="SquareImageCard-callout ">
							<div className="SquareImageCard-callout subtitle-2">
								{callout}
								{qualifier && (
									<span className="SquareImageCard-qualifier labels-caption"> {qualifier}</span>
								)}
							</div>
							{note && <span className="SquareImageCard-note labels-caption">{note}</span>}
						</div>
					)}
				</div>
			</a>
		</div>
	);
}
